import { createActions, createReducer } from 'reduxsauce'

const initialState = {
	current: 0
}

const reset = (state = initialState) => ({
	...state,
	current: 0
})

const setCurrent = (state = initialState, { current }) => ({
	...state,
	current
})

export const { Types, Creators } = createActions(
	{
		reset: null,
		setCurrent: ['current']
	},
	{ prefix: 'progress-bar/' }
)

export default createReducer(initialState, {
	[Types.RESET]: reset,
	[Types.SET_CURRENT]: setCurrent
})
